export default "__VITE_ASSET__de245ce3__";